import { shallUseTestMode } from "../hooks/useTestMode";

const isTestMode = shallUseTestMode();

const API_URL = isTestMode ? "live-api-test.wyborcza.pl" : "live-api.wyborcza.pl";
const urlStore = {
  urlJSON: `//${API_URL}/gazetapl/live/`,
  urlWS: `wss://${API_URL}/ws-live-gazeta`,
  urlScoreboard: `//${API_URL}/live/{xx}/score-board`,
};

export default urlStore;
